import React from 'react'
import coachingFooterLogo from '../assets/images/health-coach-logo.png'
import unitedStates from '../assets/images/united-states.png'
import {Link} from 'gatsby'
import {Button, Col, Row} from 'antd'

const CoachingFooter = (props) => (
    <>
  {/*<footer id="footer" className={`coaching-footer ${props.increaseFooterMargin? 'margin-80':''}`}>*/}
  {/*  <div className="inner">*/}
  {/*    <div>*/}
  {/*      <div className="footer-widgets-wrap pb-4 clearfix">*/}
  {/*        <Row className="footer-row" gutter={16}>*/}
  {/*          <Col className="col-md-8" md={8}>*/}

  {/*            <div className="widget clearfix">*/}

  {/*              <img src={coachingFooterLogo}/>*/}

  {/*            </div>*/}

  {/*          </Col>*/}

  {/*          <Col className="col-md-6" md={6}>*/}

  {/*            <div className="widget clearfix">*/}

  {/*              <h4 className="base-text">Resiliens</h4>*/}

  {/*              <ul className="list-unstyled ml-0">*/}
  {/*                <li><a className="para-text" href="https://provider.swasth.co">Clinicians</a></li>*/}
  {/*                <li><a className="para-text" href="#">Members</a></li>*/}
  {/*              </ul>*/}

  {/*            </div>*/}

  {/*          </Col>*/}
  {/*          <Col className="col-md-6" md={6}>*/}

  {/*            <div className="widget clearfix">*/}

  {/*              <h4 className="base-text">Products</h4>*/}

  {/*              <ul className="list-unstyled ml-0">*/}
  {/*                <li><a className="para-text" href="https://healthcoach.swasth.co">Behavioral Health Coach</a></li>*/}
  {/*                <li><a className="para-text" href="https://swasth.co/dbt-coach">DBT Coach</a></li>*/}
  {/*                <li><a className="para-text" href="https://swasth.co/cbt-companion">CBT Companion</a></li>*/}
  {/*                <li><a className="para-text" href="https://swasth.co/act-coach">ACT Coach</a></li>*/}
  {/*                <li />*/}

  {/*              </ul>*/}

  {/*            </div>*/}

  {/*          </Col>*/}

  {/*          <Col className="col-md-6" md={6}>*/}

  {/*            <div className="widget clearfix">*/}

  {/*              <h4 className="base-text">Social</h4>*/}

  {/*              <ul className="list-unstyled iconlist">*/}
  {/*                <li><a className="para-text" href="https://www.facebook.com/swasthco/"><img src={facebook}/></a></li>*/}
  {/*                <li><a className="para-text" href="https://www.twitter.com/swasthapps/"><img src={twitter}/></a></li>*/}
  {/*                <li><a className="para-text" href="https://www.instagram.com/swasthapps/"><img src={instagram}/></a></li>*/}
  {/*              </ul>*/}
  {/*            </div>*/}

  {/*          </Col>*/}

  {/*        </Row>*/}

  {/*      </div>*/}

  {/*      <div className="line line-sm m-0"/>*/}

  {/*    </div>*/}
  {/*    <div id="copyrights" className="nobg">*/}

  {/*      <div className="container clearfix">*/}

  {/*        <div className="col_half">*/}
  {/*          <div className="copyright-links -highlighted-secondary-text">*/}
  {/*            <Link to='/terms'>Terms of Use</Link> {'    |    '}*/}
  {/*            <Link to='/privacy'>Privacy*/}
  {/*              Policy</Link></div>*/}
  {/*          <div style={{ color: 'rgba(0,0,0,0.2)' }}>*/}
  {/*            Copyrights &copy; 2019 All Rights Reserved by Swasth Inc.<br/>*/}
  {/*          </div>*/}
  {/*          <div className='-highlighted-secondary-text'*/}
  {/*               style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>*/}
  {/*            <img style={{ position: 'initial', width: '24px', marginRight: '10px' }} src={unitedStates}/>*/}
  {/*            {' '}English*/}
  {/*          </div>*/}
  {/*        </div>*/}

  {/*      </div>*/}

  {/*    </div>*/}
  {/*  </div>*/}
  {/*</footer>*/}
      <footer
          id={'footer'}
          style={{paddingTop: 100,
            backgroundImage: `url(${require("../assets/images/top-bg.png")})`,
            backgroundSize: "cover"
          }}
          // style={props.hideFooter ? { height: 550 } : null}
      >
        <div className="inner">
         {/* <div style={{textAlign: "center"}}>
            <div className="footer-heading card-row">
              <p className="bottom-space white-text">Want to learn more about Resiliens ?</p>
              <Button className="request-demo-btn" style={{margin: "20px 0"}}>Get Started</Button>
            </div>
          </div>*/}
          <div>
            <div className="footer-widgets-wrap pb-4 clearfix">
              <Row className="footer-row" gutter={16}>
                <Col className="col-md-8 footer-info" md={8}>
                  <div className="widget clearfix">
                    <Link to="/"><img style={{width: 300, marginBottom: 10}} src={coachingFooterLogo}/></Link>
                    <p className="white-text" style={{fontSize: 12,lineHeight: 1.5}}>
                      Resiliens's Digital Health Platform offers treatment programs for Anxiety, Depression,
                      Eating Disorders, Borderline Personality Disorder, PTSD, SUDs, etc
                    </p>
                    <div className="media">
                      <a href="https://www.facebook.com/swasthco/"
                         target="_blank"><img src={require("../assets/images/facebook-icon.png")}/></a>
                      <a href="https://www.twitter.com/swasthapps/"
                         target="_blank"><img src={require("../assets/images/twitter-icon.png")}/></a>
                      <a href="https://www.instagram.com/swasthapps/"
                         target="_blank"><img src={require("../assets/images/instagram-icon.png")}/></a>
                      <a href="https://www.youtube.com/channel/UCtM20mp-kA1xkKdWA5Q-9KA"
                         target="_blank"><img src={require("../assets/images/youtube-icon.png")}/></a>
                    </div>
                  </div>

                </Col>
                <Col className="col-md-16 footer-services" md={16}>
                  <Row gutter={16}>
                    <Col className="col-md-8" md={8}>

                      <div className="widget clearfix">

                        <h5 className="white-text base-text">Resiliens</h5>

                        <ul className="list-unstyled iconlist ml-0">
                          <li><Link to="http://resiliens.com/about-us" className="para-text">About Us </Link></li>
                          <li><a href="https://clinician.swasth.co" className="para-text">Clinicians</a></li>
                          <li><a href="#" className="para-text">Employers</a></li>
                          <li><a href="https://healthcoach.swasth.co/" className="para-text">Coaching</a></li>
                        </ul>

                      </div>

                    </Col>
                    <Col className="col-md-8" md={8}>
                      <div className="widget clearfix" style={{alignItems:"baseline"}}>
                        <h5 className="white-text base-text">Products</h5>
                        <ul className="list-unstyled iconlist ml-0">
                          <li><a href="https://healthcoach.swasth.co/" className="para-text">Behavioral Health Coach</a></li>
                          <li><a href="http://resiliens.com/dbt-coach" className="para-text">DBT Coach</a></li>
                          <li><a href="http://resiliens.com/cbt-companion" className="para-text">CBT Companion</a></li>
                          <li><a href="http://resiliens.com/act-coach" className="para-text">ACT Coach</a></li>
                          {/*<li><a className="para-text" href="https://findprovider.swasth.co">Find Provider</a></li>*/}
                        </ul>

                      </div>

                    </Col>
                    <Col className="col-md-8" md={8}>
                      <div className="widget clearfix">

                        <h5 className="white-text base-text">Resources</h5>

                        <ul className="list-unstyled iconlist">
                          <li><a className="para-text" href="http://resiliens.com/blog">Blog</a></li>
                        </ul>

                      </div>
                    </Col>
                  </Row>
                </Col>

              </Row>
            </div>

            <div className="line line-sm m-0"/>

          </div>
          <div id="copyrights" className="nobg">

            <div className="container clearfix">

              <div className="col_half">
                <div className="copyright-links -highlighted-secondary-text">
                  <a href='http://resiliens.com/terms' className="white-text para-text">Terms of Use</a> {'    |    '}
                  <Link to='http://resiliens.com/privacy' className="white-text para-text">Privacy
                    Policy</Link></div>
                <div className="white-text para-text">
                  Copyrights © 2021 All Rights Reserved by Resiliens Inc.
                </div>
                <div className='white-text para-text'
                     style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <img style={{position: 'initial', width: '24px', marginRight: '10px'}} src={unitedStates}/>
                  {' '}English
                </div>
              </div>

            </div>

          </div>
        </div>
      </footer>
      </>
);

export default CoachingFooter
